import { DateInput } from "@mantine/dates";
import classes from "../../input/input.module.css";
// TODO: DateInput styling
export const dateInputProps = DateInput.extend({
    classNames: classes,
});
